import { Link, useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';

const navItems = [
  { label: 'Home', path: '/' },
  { label: 'シリーズ', path: '/series' },
  { label: 'カテゴリ', path: '/categories' },
  { label: 'About', path: '/about' },
];

export const Header = () => {
  const location = useLocation();
  const [mobileOpen, setMobileOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => { setMobileOpen(false); }, [location.pathname]);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = mobileOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [mobileOpen]);

  const isActive = (path: string) =>
    path === '/' ? location.pathname === '/' : location.pathname.startsWith(path);

  return (
    <>
      <header
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          scrolled
            ? 'bg-[#FDFAF6]/95 backdrop-blur-md border-b border-[#E8E0D5]'
            : 'bg-transparent'
        }`}
      >
        <div className="px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-14 sm:h-16 max-w-3xl mx-auto">
            {/* Logo */}
            <Link
              to="/"
              className="flex items-center gap-2 cursor-pointer whitespace-nowrap group"
            >
              <h1 className="text-sm font-bold text-[#2C2416] group-hover:text-[#5B7B6F] transition-colors tracking-tight"
                style={{ fontFamily: "'Noto Serif JP', 'Georgia', serif" }}>
                つくってなんぼ
              </h1>
            </Link>

            {/* Desktop Nav */}
            <nav className="hidden md:flex items-center gap-0">
              {navItems.map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  className={`px-4 py-2 text-sm transition-colors cursor-pointer whitespace-nowrap ${
                    isActive(item.path)
                      ? 'text-[#2C2416] font-semibold'
                      : 'text-[#7A6E62] hover:text-[#2C2416]'
                  }`}
                  style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
                >
                  {item.label}
                </Link>
              ))}
            </nav>

            {/* Right: Search + Hamburger */}
            <div className="flex items-center gap-1">
              <Link
                to="/search"
                className="w-9 h-9 flex items-center justify-center rounded-full text-[#7A6E62] hover:text-[#2C2416] hover:bg-[#F0EBE3] transition-all cursor-pointer"
                aria-label="検索"
              >
                <i className="ri-search-line text-base"></i>
              </Link>
              <button
                onClick={() => setMobileOpen(!mobileOpen)}
                className="md:hidden w-9 h-9 flex items-center justify-center rounded-full text-[#7A6E62] hover:text-[#2C2416] hover:bg-[#F0EBE3] transition-all cursor-pointer"
                aria-label="メニュー"
              >
                <i className={`${mobileOpen ? 'ri-close-line' : 'ri-menu-line'} text-base`}></i>
              </button>
            </div>
          </div>
        </div>
      </header>

      {/* Mobile Menu */}
      <div
        className={`fixed inset-0 z-40 transition-opacity duration-300 md:hidden ${
          mobileOpen ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'
        }`}
      >
        <div className="absolute inset-0 bg-[#2C2416]/30" onClick={() => setMobileOpen(false)} />
        <div
          className={`absolute top-14 sm:top-16 left-0 right-0 bg-[#FDFAF6] border-b border-[#E8E0D5] transition-transform duration-300 ease-out ${
            mobileOpen ? 'translate-y-0' : '-translate-y-4'
          }`}
        >
          <nav className="px-4 py-3 space-y-0.5">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`flex items-center px-4 py-3 text-sm transition-colors cursor-pointer ${
                  isActive(item.path)
                    ? 'text-[#2C2416] font-semibold'
                    : 'text-[#7A6E62] hover:text-[#2C2416]'
                }`}
                style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
              >
                {item.label}
              </Link>
            ))}
            <div className="border-t border-[#E8E0D5] pt-2 mt-2">
              <Link
                to="/contact"
                className="flex items-center px-4 py-3 text-sm text-[#7A6E62] hover:text-[#2C2416] transition-colors cursor-pointer"
                style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
              >
                お問い合わせ
              </Link>
            </div>
          </nav>
        </div>
      </div>
    </>
  );
};
